module.exports = __webpack_public_path__ + "static/media/vinteriors__logo.5364e7c9.svg";